import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import defaultLogo from "../static/images/rsz_real-estate-building-logo-icon-vector.jpg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faPlus,
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";

function Recomendaciones({ data, applicant, change }) {
  const [loading, setLoading] = useState(true);
  const topElementRef = useRef(null);

  const [CurrentPage, setCurrentPage] = useState(0);
  const [perPage, setperPage] = useState(10);
  useEffect(() => {
    setCurrentPage(0);
  }, [perPage]);

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    document.body.removeChild(textArea);
  }

  function copyTextToClipboard(text) {
    text = window.location.href
      .toString()
      .replace("#", "")
      .replace("/user/Empleos", text);
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(
      function () {
        toast.success("Enlace de la vacante fue copiado al portapapeles", {
          duration: 4000,
        });
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  }

  function guardarVacante(id) {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };
    axios
      .post(
        "/company-vacant/vacant-favorite/",
        {
          aplicarVacanteId: 0,
          fechaAplicacion: new Date(),
          habilidades: "string",
          insignia: 0,
          test: "false",
          applicantProfileId: applicant.applicantProfile.applicantProfileId,
          vacanteEmpresaId: id,
        },
        config
      )
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
        }
      });
  }

  function getMatches(skillsApplicant, skillsNeeded) {
    let matches = [];
    if (skillsApplicant !== undefined) {
      for (let i = 0; i < skillsNeeded.length; i++) {
        for (let j = 0; j < skillsApplicant.length; j++) {
          if (skillsNeeded[i].habilidad == skillsApplicant[j].name)
            matches.push(skillsApplicant[j].name);
        }
      }
    }
    return matches.length;
  }

  return (
    <section className="recomendaciones">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 box" ref={topElementRef}>
            <div
              className="row justify-content-between"
              id="cardrecomendaciones"
            >
              <div className="text" style={{ textAlign: "center" }}>
                Recomendaciones <span>Según perfil de usuario</span>
              </div>
              <div className="my-2 flex flex-col w-full ">
                <div className="flex flex-row w-full ">
                  <div className="btn--gradient translate-x-4 px-2 flex items-center rounded-l-xl">
                    <p className="text-white mr-4">Mostrar Por pagina</p>
                  </div>
                  <div
                    className={`px-3 py-2  z-10 text-lg ${
                      perPage == 10 ? "btn--gradient" : "bg-[#601e95]"
                    } rounded-l-xl text-white cursor-pointer`}
                    onClick={() => setperPage(10)}
                  >
                    10
                  </div>
                  <div
                    className={`px-3 py-2 text-lg ${
                      perPage == 20 ? "btn--gradient" : "bg-[#601e95]"
                    } text-white cursor-pointer`}
                    onClick={() => setperPage(20)}
                  >
                    20
                  </div>
                  <div
                    className={`px-3 py-2 text-lg ${
                      perPage == 30 ? "btn--gradient" : "bg-[#601e95]"
                    } rounded-r-xl text-white cursor-pointer`}
                    onClick={() => setperPage(30)}
                  >
                    30
                  </div>
                </div>
              </div>
              <div className="dataTable__filter">
                <span>Ordenar por:</span>
                <select name="filter" onChange={(e) => change(e)}>
                  <option value="1">Más antigua</option>
                  <option value="2">Más reciente</option>
                </select>
              </div>

              {data
                .slice(CurrentPage * perPage, CurrentPage * perPage + perPage)
                .map((item) => (
                  <div
                    key={item.vacantDTOResponse.companyVacantId}
                    className="col-md-6 one-half"
                  >
                    <div className="head" style={{ height: "90px" }}>
                      <div className="company__wrapper" id="headecomapny">
                        <div className="logo">
                          <img
                            src={
                              item.vacantDTOResponse.fotoPerfilEmpresa
                                ? item.vacantDTOResponse.fotoPerfilEmpresa
                                : defaultLogo
                            }
                            style={{ maxWidth: "92px", maxHeight: "87px" }}
                          ></img>
                        </div>

                        <div className="content">
                          <div className="cargo">
                            {item.vacantDTOResponse.cargo}
                          </div>
                          <div className="lugar">
                            {item.vacantDTOResponse.name}
                          </div>
                          <div className="cuidad">
                            {item.vacantDTOResponse.ubicacion}
                          </div>
                        </div>

                        <div className="aplicar">
                          <Link
                            to={`/user/Vacante/${item.vacantDTOResponse.companyVacantId}`}
                            /*to={{
                                pathname: "/user/Vacante",
                                state: {
                                  cargo: "Gerente de Operaciones",
                                  lugar: "BAC Credomatic",
                                  logo: bac,
                                  profileId: 5,
                                },
                              }}*/
                            className="btn btn--gradient"
                          >
                            Ver
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="body" id="bodyempleo">
                      <div className="left-side">
                        <ul>
                          <li>
                            Publicado: {item.vacantDTOResponse.fechaPublicacion}
                          </li>
                          <li>Tipo: {item.vacantDTOResponse.tipoEmpleo}</li>
                          <li>
                            Experiencia: {item.vacantDTOResponse.experiencia}
                          </li>
                        </ul>
                      </div>
                      <div className="right-side">
                        <ul id="bodyempleoul">
                          <li>
                            <i className="fa fa-eye" aria-hidden="true"></i>
                            Visualizaciones:{" "}
                            {item.vacantDTOResponse.visualizaciones}
                            <a
                              onClick={() =>
                                copyTextToClipboard(
                                  "/user/Vacante/" +
                                    item.vacantDTOResponse.companyVacantId
                                )
                              }
                            >
                              <i
                                className="fa fa-share-alt"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li>
                            <i
                              className="fa fa-folder-open"
                              aria-hidden="true"
                            ></i>
                            Aplicando:{" "}
                            {item.vacantDTOResponse.cantidadAplicantes}
                            <a
                              onClick={() =>
                                guardarVacante(
                                  item.vacantDTOResponse.companyVacantId
                                )
                              }
                            >
                              <i
                                className="fa fa-bookmark"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="footer">
                      <div className="actitudes">
                        <div
                          className="left-content"
                          style={{
                            width: "365px",
                            MinHeight: "100px",
                            overflow: "hidden",
                          }}
                        >
                          Habilidades:{" "}
                          {getMatches(
                            applicant?.listSkills,
                            item.listHabilidades
                          ) +
                            " / " +
                            item.listHabilidades?.length}
                          <span>
                            {item.listHabilidades
                              .map(function (lstHabilidates) {
                                return lstHabilidates.habilidad;
                              })
                              .join(" - ")}
                          </span>
                        </div>
                        <div className="right-content">
                          <a>
                            Salario:
                            {" " +
                              item.vacantDTOResponse.codigoMoneda +
                              " " +
                              item.vacantDTOResponse.salario}
                          </a>
                        </div>
                      </div>
                      {/*  <div className="bottom-content">
                  <ul>
                        <li>
                          <a href="#">Pide una Recomendación</a>
                        </li>
                        <li>
                          <a href="#">Referir a contacto</a>
                        </li>
                        <li>
                          <a href="#">Pregúntanos</a>
                        </li>
                      </ul>
                    </div>*/}
                    </div>
                  </div>
                ))}
              <div className="flex flex-row w-full mt-4 items-center justify-center gap-1 ">
                {data.length > perPage ? (
                  <>
                    <div
                      className="btn--gradient rounded-md px-2 py-1 text-2xl text-white cursor-pointer"
                      onClick={() => {
                        if (CurrentPage > 0) {
                          setCurrentPage(CurrentPage - 1);
                          topElementRef.current.scrollIntoView({
                            behavior: "smooth",
                          });
                        }
                      }}
                    >
                      <FontAwesomeIcon icon={faAngleLeft} />
                    </div>
                    {CurrentPage > 0 ? (
                      <div className="btn--gradient rounded-md px-2 py-1 text-2xl text-white">
                        1
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="btn--purple rounded-md px-2 py-1 text-2xl text-white">
                      {CurrentPage + 1}
                    </div>
                    {CurrentPage < Math.ceil(data.length / perPage) - 1 ? (
                      <div className="btn--gradient  rounded-md px-2 py-1 text-2xl text-white">
                        {Math.ceil(data.length / perPage)}
                      </div>
                    ) : (
                      <></>
                    )}
                    <div
                      className="btn--gradient rounded-md px-2 py-1 text-2xl text-white cursor-pointer"
                      onClick={() => {
                        if (
                          CurrentPage <
                          Math.ceil(data.length / perPage) - 1
                        ) {
                          setCurrentPage(CurrentPage + 1);
                          topElementRef.current.scrollIntoView({
                            behavior: "smooth",
                          });
                        }
                      }}
                    >
                      <FontAwesomeIcon icon={faAngleRight} />
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Recomendaciones;
